/*
 * @Date: 2023-04-21 17:06:47
 * @LastEditors: simLarry
 * @LastEditTime: 2023-04-25 11:24:32
 * @FilePath: \P1-M1-QRP-CODE\pages\restrict.js
 */
import React from "react";
import { useRouter } from "next/router";
import Header from '@/restrict/Header'; // 头部 组件
import HostConfig from "../config/Host.config";
const { isLive = false } = HostConfig.Config;

const Restrict = () => {
    const router = useRouter();
    const info = router.query.info || '';
    const openLiveChat = () => {
        var CSLive = global.open(
            'about:blank',
            '_blank',
            'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=650, height=650'
        );
        CSLive.document.title = '必威客服聊天窗口';
        CSLive.focus();
        CSLive.location.href = isLive ?
        'https://kiwifruit.glive2u.net/LiveChat/betway_cn':
        'https://kiwifruitstg.g2live.net/LiveChat/betway_cn';
    }
    return (
        <div className="restrict-page">
            <Header></Header>
            <div className="restrict-bg">
                <div className="textContent">
                    <h2>IP 限制</h2>
                    {info && <p className="ip-info">您的 IP 来自于 : {info}</p>}
                    <div className="restrict-flex">
                        <div className="item restrict-text">
                            <p className="p1">亲爱的会员,</p>
                            <p className="p2">
                                抱歉，您所在的地区不允许使用我们的服务。
                                若被发现您掩蔽真实地区位置使用我站服务，您的帐户将立即被关闭。
                                如果您有任何问题，请联系必威客服寻求协助。
                            </p>
                            <p className="p1" style={{marginTop: '12px'}}>Dear member</p>
                            <p className="p2">
                                We do not accept players from your location.
                                You are located in a restricted jurisdiction that does not permit the use of our services.
                                If you are found to be using this site with a location-making service, you account will be closed immediately.
                                If you have any inquiry, please contact our customer service.
                            </p>
                        </div>
                        <div className="item restrict-btn">
                            <a className="btn" onClick={()=>{openLiveChat()}}>在线客服</a>
                            <a className="btn" href="mailto:cs@betway88.com">cs@betway88.com</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Restrict;